import React, { useState, useEffect } from 'react';
import { Play, Mic2, Video, Music } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const studioImages = [
    'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/ar9g02tj_9e668159-70ef-4262-875f-2fe73d40ce40.jpg',
    'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/ucstm0ss_0002802f-ee60-468f-9b5b-1ecb2f15ec02.jpg',
    'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/gm29bggr_63274f00-a491-41df-aa60-219a14ba65bd.jpg',
    'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/yh8za7uf_74700ece-404f-40b6-b50a-038a1258cd5d.jpg',
    'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/c9dc9gmt_ea3b7b63-a1d0-400f-9378-cbf880751670.jpg',
  ];

  const imageAlts = [
    'Estúdio de podcast em Brasília - Estúdio Hertz com equipamentos profissionais',
    'Gravação de podcasts e cursos online em Brasília - Estúdio Hertz',
    'Estúdio audiovisual profissional em Brasília para produção de conteúdo',
    'Melhor estúdio de podcast de Brasília - Infraestrutura completa',
    'Estúdio para gravação de cursos EAD em Brasília - Palácio da Imprensa',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % studioImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [studioImages.length]);

  const features = [
    { icon: Mic2, text: 'Podcasts' },
    { icon: Video, text: 'Vídeo' },
    { icon: Music, text: 'Produção Musical' },
  ];

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Images Slideshow */}
      <div className="absolute inset-0">
        {studioImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={image}
              alt={imageAlts[index]}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
        {/* Overlay with gradient */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#1e3a5f]/95 via-[#1e3a5f]/85 to-[#48a9a6]/70"></div>
        {/* Pattern overlay */}
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.05) 1px, transparent 0)', backgroundSize: '40px 40px' }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <div className="space-y-8 animate-fade-in">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
            <div className="w-2 h-2 bg-[#ff6b35] rounded-full animate-pulse"></div>
            <span className="text-white font-medium">Ecossistema de Criação Audiovisual</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight">
            Crie, Grave,
            <br />
            <span className="text-[#ff6b35]">Conecte</span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            Estúdio de podcast e gravação de cursos online em Brasília.
            <br />
            Produção audiovisual profissional com 25+ anos de experiência.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <Button
              onClick={() => window.open('https://wa.me/5561985533770', '_blank')}
              size="lg"
              className="bg-[#ff6b35] hover:bg-[#ff5520] text-white px-8 py-6 text-lg rounded-full font-semibold shadow-2xl hover:shadow-[#ff6b35]/50 transform hover:scale-105 transition-all duration-300"
            >
              <Play className="mr-2" size={20} />
              Iniciar Projeto
            </Button>
            <Button
              onClick={() => document.getElementById('trabalhos').scrollIntoView({ behavior: 'smooth' })}
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-[#1e3a5f] px-8 py-6 text-lg rounded-full font-semibold transition-all duration-300"
            >
              Ver Portfólio
            </Button>
          </div>

          {/* Features */}
          <div className="flex flex-wrap items-center justify-center gap-8 pt-12">
            {features.map((feature, index) => (
              <div
                key={index}
                className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20 hover:bg-white/20 transition-all duration-300"
              >
                <feature.icon className="text-[#ff6b35]" size={24} />
                <span className="text-white font-medium">{feature.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center space-y-2 animate-bounce">
          <span className="text-white text-sm font-medium">Role para explorar</span>
          <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-white rounded-full animate-scroll"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;